import { Calendar, ChevronDown, ChevronUp, Eye, Mail, Users } from "lucide-react";
import DOMPurify from 'dompurify';

// Utilidades
const formatDate = (dateString) => {
  return new Date(dateString).toLocaleString('es-ES', {
    year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit'
  });
};

// Componente de Email Card
const EmailCard = ({ email, expanded, onToggleExpand, onViewDetails }) => (
  <div className="border border-gray-200 rounded-xl hover:shadow-lg hover:border-gray-300 transition-all duration-300 ease-in-out transform hover:-translate-y-0.5">
    <div className="p-6">
      <div className="flex items-start justify-between">
        <div className="flex-1 min-w-0">
          {/* Header con subject y tipo */}
          <div className="flex items-center gap-3 mb-3">
            <Mail className="w-5 h-5 text-[#0488AF] flex-shrink-0" />
            <h3 className="text-lg font-semibold text-[#09274A] truncate flex-1">
              {email.subject}
            </h3>
            {email.type && (
              <span className="bg-[#0488AF] bg-opacity-10 text-[#0488AF] text-sm font-medium px-3 py-1.5 rounded-full whitespace-nowrap">
                {email.type}
              </span>
            )}
          </div>
          
          {/* Metadata con iconos */}
          <div className="flex items-center gap-6 text-gray-600 mb-3">
            <div className="flex items-center gap-2">
              <Users className="w-4 h-4" />
              <span className="text-sm font-medium">
                {email.to.length} destinatario{email.to.length !== 1 ? 's' : ''}
              </span>
            </div>
            <div className="flex items-center gap-2">
              <Calendar className="w-4 h-4" />
              <span className="text-sm font-medium">{formatDate(email.createdAt)}</span>
            </div>
          </div>

          {/* Lista de destinatarios */}
          <div className="flex flex-wrap gap-2 mb-3">
            {email.to.slice(0, 3).map((recipient, index) => (
              <span 
                key={index} 
                className="bg-[#09274A] bg-opacity-10 text-[#09274A] text-sm font-medium px-3 py-1.5 rounded-full hover:bg-opacity-15 transition-colors duration-200"
              >
                {recipient}
              </span>
            ))}
            {email.to.length > 3 && (
              <span className="text-sm text-gray-500 px-3 py-1.5 font-medium">
                +{email.to.length - 3} más
              </span>
            )}
          </div>

          {/* Contenido expandible con animación */}
          <div className={`overflow-hidden transition-all duration-500 ease-in-out ${
            expanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}>
            <div className="mt-4 pt-4 border-t border-gray-100">
              <div className="transform transition-transform duration-300 ease-in-out">
                <div className="text-sm text-gray-700 leading-relaxed">
                  <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(email.content) }} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Botones de acción */}
        <div className="flex items-center gap-1 ml-6">
          <button
            onClick={() => onViewDetails(email)}
            className="p-3 text-[#0488AF] hover:text-white hover:bg-[#0488AF] rounded-lg transition-all duration-200 transform hover:scale-105 active:scale-95"
            title="Ver detalles"
          >
            <Eye className="w-5 h-5" />
          </button>
          <button
            onClick={() => onToggleExpand(email.id)}
            className={`p-3 text-gray-600 hover:text-[#09274A] hover:bg-gray-100 rounded-lg transition-all duration-200 transform hover:scale-105 active:scale-95 ${
              expanded ? 'bg-gray-50' : ''
            }`}
            title={expanded ? "Contraer" : "Expandir"}
          >
            <div className={`transform transition-transform duration-300 ${expanded ? 'rotate-180' : 'rotate-0'}`}>
              <ChevronDown className="w-5 h-5" />
            </div>
          </button>
        </div>
      </div>
    </div>
  </div>
);

export default EmailCard;